export default __webpack_public_path__ + "static/media/Pro-pic.de11f2b8.png";